import React from 'react';

import { Grid, Typography } from '@material-ui/core';
import { TextField, Step } from '../SteppedForm';

import rules from './rules';

const StepOperatorlic = (props) => {
  return (
    <Step
      id="operatorlic"
      title="Operator Accreditation Details"
      skip={(formdata) => !props.inStates(['nsw']) || formdata.onboardingFor === 'vehicle'}>
      {props.stateconfig().deferoperatorcred ? (
        <Typography variant="body1" class="formQuestion">
          If you do not have accreditation, you will have to apply for Operator Accreditation (Small
          Passenger) with DPTI
        </Typography>
      ) : (
        ''
      )}
      <Grid container>
        <Grid item xs={12} lg={12}>
          <TextField
            id="operatoraccno"
            label={props.getTaxiServiceLicenceName() + ' #'}
            valid={rules.length(1, 12)}
            modify={(value) => props.limitLength(value, 12)}
            required
          />
        </Grid>
      </Grid>
    </Step>
  );
};

export default StepOperatorlic;
